var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-footer pa-5" },
    [
      _c(
        "v-row",
        { staticClass: "align-end" },
        [
          _c("v-col", {
            staticClass: "d-none d-md-block",
            attrs: { col: "4" }
          }),
          _c(
            "v-col",
            {
              staticClass: "text-center text-sm-left text-md-center",
              attrs: { cols: "12", sm: "6", md: "4", lg: "4" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "primary--text",
                  attrs: { target: "blank" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.openRoute("privacy")
                    }
                  }
                },
                [_vm._v("Datenschutz  |  ")]
              ),
              _c(
                "a",
                {
                  staticClass: "primary--text",
                  attrs: { target: "blank" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.openRoute("impressum")
                    }
                  }
                },
                [_vm._v("Impressum")]
              )
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "text-center text-sm-right",
              attrs: { cols: "12", sm: "6", md: "4", lg: "4" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    href:
                      "https://www.bundesregierung.de/breg-de/bundesregierung/staatsministerin-fuer-kultur-und-medien",
                    target: "blank"
                  }
                },
                [
                  _c("img", {
                    staticClass: "logo--germany",
                    attrs: { src: require("@/assets/images/logo_germany.png") }
                  })
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }